import React from "react"
import ReactDOM from "react-dom"
import EpiForms from "./epi-forms-component"

export default class EpiFormsModule {
  constructor(elem) {
    const self = this
    self.elem = elem
    self.modelJson = elem.dataset.modelJson && JSON.parse(elem.dataset.modelJson)
    this.init()
    return self
  }

  init() {
    const self = this
    ReactDOM.unmountComponentAtNode(self.elem)
    ReactDOM.render(<EpiForms {...self.modelJson} />, self.elem)
  }
}
